import { createResourcesFormData,  viewResourcesDetailFormData } from "../data/CreateResourcesForm.data";
import { viewResourcesFormData } from "../data/ViewResourcesForm.data";

export const setAllDropDownField = (apiResponse) => {
    const filterDropDownList = (dropdownName) => {
        return apiResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({
                    value: item.id,
                    label: item.name,
                });
            }
            return acc;
        }, []);
    }

    const dropdownLists = {
        "membershipType": filterDropDownList("resources membership"),
        "category": filterDropDownList("Resource Category"),
    };

     const formFields = [...createResourcesFormData.formFields,...viewResourcesFormData.formFields,...viewResourcesDetailFormData.formFields];

    formFields.forEach(field => {
        const dropdownList = dropdownLists[field?.id];
        if (dropdownList) {
            field.fieldSetting.options = dropdownList;
        }
    });
};